import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, catchError, throwError } from 'rxjs';

import {
  DisposalSite,
  DisposalSiteObject,
} from '@digital-platform/disposal-sites/domain';

@Injectable({
  providedIn: 'root',
})
export class DisposalSitesService {
  constructor(private httpClient: HttpClient) {}

  public getDisposalSites(): Observable<DisposalSite[]> {
    return this.httpClient.get<DisposalSite[]>('/api/disposal-sites');
  }

  public getDeepWellSites(): Observable<DisposalSite[]> {
    return this.httpClient.get<DisposalSite[]>(
      '/api/disposal-sites/type/deepwell'
    );
  }

  public findDisposalSites(division: string): Observable<DisposalSite[]> {
    const url = `/api/disposal-sites/division/${division}`;
    const httpOptions = {};
    return this.httpClient.get<DisposalSite[]>(url, httpOptions);
  }

  public createDisposalSite(
    disposalSiteObject: DisposalSiteObject
  ): Observable<DisposalSiteObject> {
    const url = '/api/disposal-sites/new';
    const body = disposalSiteObject;
    console.error('facadeService--DSBodyObj--', body);
    return this.httpClient.post<DisposalSiteObject>(url, body).pipe(
      map((response) => response),
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(error);

      switch (error.status) {
        case 403:
          return throwError(() =>
            Error(
              'Access denied while loading Disposal Site, please try again later or contact Republic Services'
            )
          );
      }
    }

    let message = 'Something bad happened; please try again later.';
    if (error.error.message) {
      message = error.error.message;
    }
    return throwError(() => message);
  }
}
